export default __webpack_public_path__ + "static/media/photo--sm--105.f8d3b150.jpg";